module.exports = __webpack_public_path__ + "static/media/21ECLAC4.ce8ed08f.jpg";